import NumberFormatter from '@/utils/bn';
import { useLocale, useTranslations } from 'next-intl';

type BatchBadgeProps = {
  batchNumber: number;
};

export default function BatchNumberBadge({ batchNumber }: BatchBadgeProps) {
  const locale = useLocale();
  const t = useTranslations();

  return (
    <span className="bg-gradient-to-br from-gray-50 to-gray-100/50 text-sm items-center gap-2 p-1 px-2 rounded-sm w-fit inline ml-2 -mt-1 whitespace-nowrap border-1	border-primary-200">
      {t('course-card-live.batch')}{' '}
      {locale === 'bn' ? NumberFormatter(batchNumber) : batchNumber}
    </span>
  );
}
